
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/rates/[id]/[bookingStep]/[room]",
      function () {
        return require("private-next-pages/rates/[id]/[bookingStep]/[room].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/rates/[id]/[bookingStep]/[room]"])
      });
    }
  